import { translate } from '@portal/services/i18n';
import { UserRole } from '@portal/enum/userRole';

export const getUserRoleDisplay = (role: string): string => {
  switch (role) {
    case UserRole.EXTERNAL_MULTIACCESS:
      return translate(
        'PAGES.MY_ACCOUNT.MULTI_ACCESS.ROLES.EXTERNAL_MULTIACCESS'
      );
    case UserRole.INTERNAL_MULTIACCESS:
      return translate(
        'PAGES.MY_ACCOUNT.MULTI_ACCESS.ROLES.INTERNAL_MULTIACCESS'
      );
    case UserRole.MAIN:
      return translate('PAGES.MY_ACCOUNT.MULTI_ACCESS.ROLES.MAIN');
    default:
      return role;
  }
};
